import Api from "js/core/api";
import * as googleAuth from "js/core/utilities/googleAuth";

class GoogleContactsDataService {
    /**
     * Grants our app offline access to user's Google Contacts.
     */
    grantOfflineAccess(userUid) {
        return googleAuth.grantOfflineAccess("https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/admin.directory.user.readonly", userUid);
    }

    async hasOfflineAccess() {
        const { hasTokens } = await Api.hasGoogleTokensForScope.get({ scope: "https://www.googleapis.com/auth/contacts.readonly" });
        return hasTokens;
    }

    async fetchContacts() {
        return await Api.getGoogleContacts.get();
    }
}

export const googleContactsDataService = new GoogleContactsDataService();
